var _style, _circle, _g, _path, _path2, _path3, _g2, _path4, _g3, _g4, _path5, _g5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    className: "icon share-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .st0{fill:#FFFFFF;stroke:currentColor;stroke-width:8;stroke-miterlimit:10;}\n    .st1{fill:none;stroke:#FFFFFF;stroke-width:8;stroke-linecap:round;stroke-miterlimit:10;}\n    .st2{stroke:#FFFFFF;stroke-width:8;stroke-linecap:round;stroke-miterlimit:10;}\n    .st3{fill:none;stroke:#FFFFFF;stroke-width:3.1884;stroke-linecap:round;stroke-miterlimit:10;}\n    .st4{stroke:#FFFFFF;stroke-width:3.1884;stroke-linecap:round;stroke-miterlimit:10;}\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1750.49,
    cy: 114.03,
    r: 71.58
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1718.19,153.96"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1749.62,94.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1775.49,151.08h-50c-7.73,0-14-6.27-14-14v-30c0-7.72,5.94-14,13.24-14h9.09c1.92,0,3.69,1.29,4.07,3.17     c0.52,2.57-1.44,4.83-3.92,4.83h-9.22c-2.85,0-5.26,2.76-5.26,6.03v29.97c0,3.31,2.69,6,6,6h50c3.31,0,6-2.69,6-6v-30     c0-3.25-2.23-6-4.87-6l-8.72,0c-1.92,0-3.69-1.29-4.07-3.17c-0.52-2.57,1.44-4.83,3.92-4.83h8.84c7.12,0,12.91,6.3,12.91,14.05     v29.95C1789.49,144.81,1783.22,151.08,1775.49,151.08z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1764.73,78.37l-11.45-9.24c-0.83-0.67-1.84-0.94-2.82-0.86c-0.94-0.03-1.88,0.25-2.63,0.86l-11.94,9.63     c-0.73,0.59-1.17,1.5-1.12,2.44c0.21,4.02,4.2,5.35,6.62,3.39l4.94-3.99v40.71c0,0.96,0.44,1.88,1.22,2.44     c3.26,2.33,6.78,0.05,6.78-3.04V80.26l5.37,4.33c0.74,0.6,1.63,0.89,2.51,0.89c1.17,0,2.33-0.51,3.12-1.49     C1766.72,82.27,1766.45,79.76,1764.73,78.37z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1718.19,153.96"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1749.62,94.9"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3.09,32.21"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3.09,32.21"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M15.65,9.86"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.85,9.58h-3.34c-0.94,0-1.67,0.85-1.48,1.82c0.14,0.71,0.81,1.2,1.54,1.2l3.29,0c1,0,1.84,1.04,1.84,2.26v11.32       c0,1.25-1.01,2.26-2.26,2.26H6.56c-1.25,0-2.26-1.01-2.26-2.26V14.87c0-1.23,0.91-2.28,1.98-2.28h3.48c0.94,0,1.67-0.85,1.48-1.82       c-0.14-0.71-0.81-1.2-1.54-1.2H6.28c-2.76,0-5,2.37-5,5.28v11.32c0,2.92,2.37,5.28,5.28,5.28h18.87c2.92,0,5.28-2.37,5.28-5.28       v-11.3C30.72,11.96,28.53,9.58,25.85,9.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.57,6.38l1.87-1.5v15.37c0,0.36,0.17,0.71,0.46,0.92c1.23,0.88,2.56,0.02,2.56-1.15l0-15.27l2.03,1.64       c0.28,0.23,0.61,0.33,0.95,0.33c0.44,0,0.88-0.19,1.18-0.56c0.52-0.65,0.42-1.6-0.23-2.12l-4.32-3.49       c-0.31-0.25-0.69-0.36-1.06-0.33c-0.35-0.01-0.71,0.1-0.99,0.33l-4.51,3.63c-0.28,0.22-0.44,0.57-0.42,0.92       C10.14,6.61,11.65,7.11,12.57,6.38z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M15.65,9.86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon-share.a9e8245e457cd4d499e3c4b9da47e841.svg";
export { ForwardRef as ReactComponent };